module.exports = __webpack_public_path__ + "img/arrow.4f216d36.svg";